import React, { useEffect, useState } from "react";
import axios from "axios";
import { getUrl } from "../../MIS/Global";
import { Button } from "react-bootstrap";
import ButtonEL from "../GlobalComponent/Elements/ButtonEL";

const DraggableList = () => {
  const apiClient = axios.create({
    baseURL: getUrl(),
    headers: { "Content-Type": "application/json" },
  });

  const [items, setItems] = useState([]);
  const [isChanged, setIsChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleGetData = async () => {
    try {
      const res = await apiClient.get("category/");
      const sortedCategories = res?.data?.data.sort((a, b) => a.seqno - b.seqno);
      setItems(sortedCategories);
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    if (dragIndex === dropIndex) return;
  
    const updatedItems = [...items];
    const draggedItem = updatedItems.splice(dragIndex, 1)[0];
    updatedItems.splice(dropIndex, 0, draggedItem);
  
    // Update seqno based on new index
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      seqno: index, // Assign new sequence number
    }));
  
    setItems(reorderedItems);
    setIsChanged(true);
  };

  const handleSubmit = async () => {
    setIsLoading(true)
    try {
      await apiClient.patch("category/", {
        categories: items.map((item, index) => ({ id: item.id, seqno: index })),
        action:'reorder'
      });
      alert("Order saved successfully!");
      setIsChanged(false);
    } catch (error) {
      // console.error("Error saving order", error);
    }finally{
      setIsLoading(false)
    }
  };

  useEffect(() => {
    handleGetData();
  }, []);

  return (
    <div className="container mt-4">
      <style>
        {`
        .draggable-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 12px;
        }

        .draggable-item {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 12px;
          cursor: grab;
          transition: transform 0.2s, background 0.3s;
          user-select: none;
          border: 1px solid #ddd;
          border-radius: 8px;
          background: #fff;
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
          text-align: center;
        }

        .draggable-item:hover {
          background: #f8f9fa;
          transform: scale(1.05);
        }

        .drag-handle {
          font-size: 20px;
          color: #007bff;
        }

        .save-btn {
          margin-top: 15px;
          width: 100%;
        }
        `}
      </style>

      <h4 className="text-center mb-3">Drag & Reorder Categories</h4>
      <div className="draggable-grid">
        {items.map((item, index) => (
          <div
            key={item.id}
            className="draggable-item"
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
          >
            {item.catgname}            
          </div>
        ))}
      </div>

      {isChanged && (
        <ButtonEL
          type="button"
          variant="primary"
          isLoading={isLoading}
          loadingText="Saving..."          
          className="save-btn"
          onClick={handleSubmit}
        >
          Save Order
        </ButtonEL>
       
      )}
    </div>
  );
};

export default DraggableList;
